import styled, { css } from 'styled-components';
import { ButtonProps } from '../../types';

interface StyledButtonProps {
  $primary?: boolean;
  $secondary?: boolean;
  $option?: boolean;
}

const Button = styled.button<StyledButtonProps>`
  display: inline-block;
  font-size: 1.8rem;
  font-weight: 500;
  font-family: var(--font-secondary);
  padding: 1.2rem 2.4rem;
  border: 1px solid var(--color-medium);
  border-radius: 0.5rem;
  cursor: pointer;
  transition: all 0.3s;
  letter-spacing: 0.5px;

  ${(props) =>
    props.$primary &&
    css`
      background-color: var(--color-theme);
      color: var(--color-light);
      border: 1px solid var(--color-theme);

      &:hover {
        background-color: #c9a227; /* Darker gold */
        border-color: #c9a227;
      }
    `}

  ${(props) =>
    props.$secondary &&
    css`
      background-color: var(--color-light);
      color: var(--color-darkest);
      border: 1px solid var(--color-medium);

      &:hover {
        background-color: var(--color-medium);
        border-color: var(--color-theme);
      }
    `}

  ${(props) =>
    props.$option &&
    css`
      display: block;
      width: 100%;
      margin-bottom: 1.2rem;
      text-align: left;
      background-color: var(--color-light);
      color: var(--color-darkest);
      border: 1px solid var(--color-medium);
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);

      &:hover:not(:disabled) {
        transform: translateX(0.8rem);
        border-color: var(--color-theme);
      }

      &:disabled {
        cursor: not-allowed;
      }

      &.answer {
        border-left: 4px solid var(--color-theme);
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      &.selected {
        background-color: rgba(212, 175, 55, 0.05);
        border-color: var(--color-theme);
      }

      &.correct {
        background-color: rgba(212, 175, 55, 0.1);
        border: 1px solid var(--color-theme);
        color: var(--color-darkest);
      }

      &.wrong {
        background-color: rgba(192, 192, 192, 0.2);
        border: 1px solid var(--color-accent);
        color: var(--color-darkest);
      }
    `}
`;

export default Button;
